import { getStructure } from "../utils";
export default {
  props: {
    emptySkeleton: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    getStructure,
    ordinalIndex(index) {
      return this.$options.filters.formatNumeral(index + 1, "0o");
    }
  }
};